import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import "./PackingBandModal.css";

const PackingBandModal = ({ 
  show, 
  setShow, 
  record, 
  mode, 
  onSave, 
  date, 
  lotNumber,
  shift // "day" or "night"
}) => {
  const { _t } = useTranslator();

  const initialFormData = {
    lot_number: lotNumber || "",
    shift: shift || "day",
    band_1_20lb: "",
    band_1_10lb: "",
    band_1_people: "",
    band_2_20lb: "",
    band_2_10lb: "",
    band_2_people: "",
    band_3_20lb: "",
    band_3_10lb: "",
    band_3_people: "",
    band_4_20lb: "",
    band_4_10lb: "",
    band_4_people: "",
    band_5_20lb: "",
    band_5_10lb: "",
    band_5_people: "",
    date: date || "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (show) {
      if (record && mode === "edit") {
        setFormData({
          lot_number: record.lot_number || lotNumber || "",
          shift: shift || "day",
          band_1_20lb: record.band_1_20lb || "",
          band_1_10lb: record.band_1_10lb || "",
          band_1_people: record.band_1_people || "",
          band_2_20lb: record.band_2_20lb || "",
          band_2_10lb: record.band_2_10lb || "",
          band_2_people: record.band_2_people || "",
          band_3_20lb: record.band_3_20lb || "",
          band_3_10lb: record.band_3_10lb || "",
          band_3_people: record.band_3_people || "",
          band_4_20lb: record.band_4_20lb || "",
          band_4_10lb: record.band_4_10lb || "",
          band_4_people: record.band_4_people || "",
          band_5_20lb: record.band_5_20lb || "",
          band_5_10lb: record.band_5_10lb || "",
          band_5_people: record.band_5_people || "",
          date: date || "",
        });
      } else {
        setFormData({
          ...initialFormData,
          lot_number: lotNumber || "",
          date: date || "",
          shift: shift || "day",
        });
      }
    }
  }, [show, record, mode, date, lotNumber, shift]);

  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (onSave) {
      onSave(formData);
    }
    handleClose();
  };

  const shiftLabel = shift === "day" ? _t("day_shift", "Day Shift") : _t("night_shift", "Shift 2");

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "edit"
          ? `${_t("edit", "Edit")} ${_t("packing_band_log", "Packing Band Log")} - ${shiftLabel}`
          : `${_t("add", "Add")} ${_t("packing_band_log", "Packing Band Log")} - ${shiftLabel}`
      }
      children={formData}
    >
      <Row className="mb-3">
        <Col lg={6}>
          <div className="header-info">
            <span className="info-label">{_t("lot_number", "Lot Number")}</span>
            <span className="info-value">{formData.lot_number}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="header-info">
            <span className="info-label">{_t("shift", "Shift")}</span>
            <span className="info-value">{shiftLabel}</span>
          </div>
        </Col>
      </Row>

      <div className="band-table-wrapper">
        <table className="band-table">
          <thead>
            <tr>
              <th>{_t("band", "Band")}</th>
              <th>{_t("twenty_pound_boxes", "20 Pound Boxes")}</th>
              <th>{_t("ten_pound_boxes", "10 Pound Boxes")}</th>
              <th>{_t("number_of_people", "Number of people")}</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((bandNum) => (
              <tr key={bandNum}>
                <td className="band-label">{_t("band", "Band")} {bandNum}</td>
                <td>
                  <input
                    type="number"
                    name={`band_${bandNum}_20lb`}
                    value={formData[`band_${bandNum}_20lb`]}
                    onChange={handleChange}
                    placeholder={"0"}
                    className="band-input"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name={`band_${bandNum}_10lb`}
                    value={formData[`band_${bandNum}_10lb`]}
                    onChange={handleChange}
                    placeholder={"0"}
                    className="band-input"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name={`band_${bandNum}_people`}
                    value={formData[`band_${bandNum}_people`]}
                    onChange={handleChange}
                    placeholder={"0"}
                    className="band-input"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Row className="mt-3">
        <Col className="text-end">
          <Button
            label={_t("cancel", "Cancel")}
            size="small"
            onClick={handleClose}
            className="btn-cancel"
          />
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            className="btn-save"
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default PackingBandModal;
